module.exports = __webpack_public_path__ + "media/images/p2-1fb514dc9abca36fea042d1ee1b18a9d.jpg";